import { render, staticRenderFns } from "./AdsType17.vue?vue&type=template&id=2f9fc45f&scoped=true&"
import script from "./AdsType17.vue?vue&type=script&lang=js&"
export * from "./AdsType17.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./AdsType17.vue?vue&type=style&index=0&id=2f9fc45f&prod&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2f9fc45f",
  null
  ,true
)

export default component.exports